import './index.scss';
import { Check } from 'react-feather';
import { useTranslation } from 'react-i18next';
import { useProfile } from '../../../../store/Auth/authHooks';

interface Props {
  successMessage:
    | 'MEDICAL_FORM_APPROVAL_SUCCESS_MESSAGE_CONTENT'
    | 'MEDICAL_FORM_VALID_SUCCESS_MESSAGE_CONTENT';
  noGymTour?: boolean;
}

const MedicalFormSuccessMessageContent = (props: Props) => {
  const profile = useProfile();
  const { t } = useTranslation();

  return (
    <div className="medical-form-message-content">
      <div className="medical-form-message-content-icon">
        <i className="icon-dumbbell" />
        <div className="medical-form-message-content-sub-icon">
          <Check />
        </div>
      </div>
      <div className="medical-form-message-content-title" dir="rtl">
        {t('MEDICAL_FORM_SUCCESS_MESSAGE', { fullName: profile?.fullName })}
      </div>
      <div className="medical-form-message-content-message" dir="rtl">
        {t(props.successMessage)}
      </div>
      {!props.noGymTour && (
        <div className="medical-form-message-content-message" dir="rtl">
          {t('MEDICAL_FORM_SUCCESS_MESSAGE_SUB_CONTENT')}
        </div>
      )}
    </div>
  );
};

export default MedicalFormSuccessMessageContent;
